import { c as _c } from "react/compiler-runtime";
import { SubjectsAnalysisResponseDTO } from "@/entities/hospital/model/types";
import { getHospitalAnalysisDisplayLabel } from "@/entities/hospital/lib/analysis-label-localization";
import SubjectRatioRow from "../SubjectRatioRow";
import { useLocale } from "next-intl";
interface TreatmentSubjectRatioListProps {
  treatmentSubjectRatioList: SubjectsAnalysisResponseDTO[];
}
const TreatmentSubjectRatioList = t0 => {
  const $ = _c(9);
  const {
    treatmentSubjectRatioList
  } = t0;
  const locale = useLocale();
  let t1;
  let t2;
  if ($[0] !== locale || $[1] !== treatmentSubjectRatioList) {
    let t3;
    if ($[4] !== locale) {
      t3 = item => {
        const displayTreatment = getHospitalAnalysisDisplayLabel(item.treatment, locale);
        return displayTreatment ? [{
          ...item,
          displayTreatment
        }] : [];
      };
      $[4] = locale;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    const displayRows = treatmentSubjectRatioList.flatMap(t3);
    t1 = "flex flex-col gap-1.5 px-5 pb-6";
    t2 = displayRows.map(_temp);
    $[0] = locale;
    $[1] = treatmentSubjectRatioList;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default TreatmentSubjectRatioList;
function _temp(item_0) {
  return <SubjectRatioRow key={item_0.treatment} treatment={item_0.treatment} displayTreatment={item_0.displayTreatment} count={item_0.count} percent={item_0.percent} />;
}